import type { ApiClientConfig } from '@signalvote/api-client';
import type { SubscriptionStatus } from '@signalvote/shared';
import { API_BASE_URL, SUBSIDIARY_CODE } from '../config';
import { useCampaignStore } from '../stores';
import { authService } from '../services/authService';
import { redirectToLegalAccept } from './legalAccept';
import { onServerWrites } from './serverWrites';

/**
 * The web's api-client renews and clears the session through `authService`, the same code
 * `authenticatedFetch` uses, so the two doors share one token store and one refresh call.
 */
export function webApiClientConfig(): ApiClientConfig {
  return {
    baseURL: API_BASE_URL,
    getAuthToken: () => authService.getToken(),
    refreshAuth: async () => (await authService.refreshToken()) !== null,
    onAuthError: () => {
      authService.clearSession();
      const { pathname, search, hash } = window.location;
      window.location.href = `/login?redirect=${encodeURIComponent(pathname + search + hash)}`;
    },
    onPaymentRequired: (subscriptionStatus?: string) => {
      const newStatus = (subscriptionStatus === 'Canceled' ? 'Canceled' : 'Unpaid') as SubscriptionStatus;
      const campaign = useCampaignStore.getState().selectedCampaign;
      if (campaign && campaign.subscriptionStatus !== newStatus) {
        useCampaignStore.getState().selectCampaign({
          ...campaign,
          subscriptionStatus: newStatus,
        });
      }
    },
    onLegalAcceptanceRequired: redirectToLegalAccept,
    onWrites: onServerWrites,
    // Use store value if available (after login), otherwise use build-time config
    getSubsidiaryCode: () => useCampaignStore.getState().subsidiaryCode || SUBSIDIARY_CODE,
    getCampaignId: () => useCampaignStore.getState().selectedCampaign?.id ?? null,
  };
}
